import React, { useEffect, useState } from 'react';
import { Table, Spinner, Badge, Form, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import client from '../api/client';
import PageHeader from '../components/PageHeader';
import { useAuth } from '../context/AuthContext';
import { fmtMoney, fmtDate } from '../utils/format';

const Commissions = () => {
  const { user } = useAuth();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [status, setStatus] = useState('');

  const load = async () => {
    setLoading(true);
    try {
      const params = {};
      if (status) params.status = status;
      const { data } = await client.get('/commissions', { params });
      setItems(data);
    } finally { setLoading(false); }
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, []);

  const totals = items.reduce(
    (acc, c) => {
      if (c.status === 'paid') acc.paid += c.amount || 0;
      else if (c.status === 'pending') acc.pending += c.amount || 0;
      return acc;
    },
    { paid: 0, pending: 0 }
  );

  const setPaid = async (c) => {
    try {
      await client.put(`/commissions/${c._id}`, { status: 'paid', paidOn: new Date() });
      toast.success('Marked paid');
      load();
    } catch (ex) {
      toast.error('Failed');
    }
  };

  return (
    <div>
      <PageHeader title="Commissions" subtitle="Sales agent commission tracker" />

      <div className="row g-3 mb-3">
        <div className="col-md-3"><div className="bg-white rounded p-3 border"><small className="text-muted">Total Paid</small><h5 className="mb-0 text-success">{fmtMoney(totals.paid)}</h5></div></div>
        <div className="col-md-3"><div className="bg-white rounded p-3 border"><small className="text-muted">Total Pending</small><h5 className="mb-0 text-warning">{fmtMoney(totals.pending)}</h5></div></div>
      </div>

      <div className="d-flex gap-2 mb-3">
        <Form.Select style={{ maxWidth: 200 }} value={status} onChange={(e) => setStatus(e.target.value)}>
          <option value="">All</option>
          <option value="pending">Pending</option>
          <option value="paid">Paid</option>
          <option value="cancelled">Cancelled</option>
        </Form.Select>
        <Button onClick={load}><i className="bi bi-arrow-clockwise"></i> Refresh</Button>
      </div>

      {loading ? <Spinner animation="border" /> : (
        <Table hover responsive>
          <thead>
            <tr>
              <th>Booking</th><th>Sales Agent</th><th>Amount</th><th>Status</th>
              <th>Mode</th><th>Target Date</th><th>Paid On</th><th>Reference</th><th></th>
            </tr>
          </thead>
          <tbody>
            {items.length === 0 && <tr><td colSpan={9} className="text-center text-muted py-4">No commission records</td></tr>}
            {items.map((c) => (
              <tr key={c._id}>
                <td>
                  <Link to={`/bookings/${c.booking?._id}`}>{c.booking?.bookingNo}</Link>
                  <br /><small className="text-muted">Unit {c.booking?.unitNo} · {c.booking?.project?.name}</small>
                </td>
                <td>{c.salesAgent?.name}</td>
                <td>{fmtMoney(c.amount)}</td>
                <td><Badge bg={c.status === 'paid' ? 'success' : c.status === 'pending' ? 'warning' : 'secondary'} className="text-uppercase">{c.status}</Badge></td>
                <td className="text-uppercase">{c.mode}</td>
                <td>{fmtDate(c.targetDate)}</td>
                <td>{fmtDate(c.paidOn)}</td>
                <td>{c.referenceNo || '-'}</td>
                <td className="text-end">
                  {c.status === 'pending' && ['admin', 'support'].includes(user.role) && (
                    <Button size="sm" variant="outline-success" onClick={() => setPaid(c)}>Mark Paid</Button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
    </div>
  );
};

export default Commissions;
